import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ViewFareDetailsModalComponent } from '../../modals/view-fare-details-modal/view-fare-details-modal.component';
import { CommonService, ObservableService } from '@bst-frontend/shared';

@Component({
  selector: 'bst-frontend-fare-details',
  templateUrl: './fare-details.component.html',
  styleUrls: ['./fare-details.component.css'],
})
export class FareDetailsComponent {
  @Input() orderDetails: any;
  showEdit = ['invoiceUploaded', 'paid'];
  constructor(
    private modalService: NgbModal,
    public _commonService: CommonService,
    private observableService: ObservableService
  ) {}
  
  openViewEstimateModal() {
    const modalRef = this.modalService.open(ViewFareDetailsModalComponent, {
      centered: true,
      size: 'lg', // options: sm, lg, xl
      backdrop: 'static', // optional: prevent closing by click outside
    });

    modalRef.componentInstance.orderDetails = this.orderDetails;

    modalRef.result
      .then((result) => {
        if (result === 'saved') {
          console.log('estimate added!');
        }
      })
      .catch(() => {
        console.log('errror');
      });
  }

  openAddEstimateModal() {
    this.observableService.editFare$.next();
  }
}
